export const isNotificationAllowed = (notification, user) => {
  if (!user) {
    return false;
  }
  if (
    notification.type === "sorting_error" ||
    notification.type === "sorting_campaign" ||
    notification.type === "packmat" ||
    notification.type === "collection"
  ) {
    return user.receiveAnomalyPush;
  }
  if (notification.type === "filling_level") {
    return user.receiveFillingPush;
  }
  if (notification.type === "characterization") {
    return user.recieveCharacterizationPush;
  }
  if (notification.type === "qualicheck") {
    return user.recieveQualicheckPush ?? user.recieveCharacterizationPush;
  }
  return true;
};

export const countUnreadAllowedNotifications = (notifications, user) => {
  return notifications.filter(
    (notification) =>
      isNotificationAllowed(notification, user) && !notification.read,
  ).length;
};

export const buildNotificationDetailState = (notification) => ({
  notificationId: notification._id,
  title: notification.title,
  description: notification.description,
  date: notification.date,
  imageUrl: notification.imageUrl,
  xBox: notification.xBox,
  yBox: notification.yBox,
  wBox: notification.wBox,
  hBox: notification.hBox,
  detectedObjects: notification.detectedObjects,
  containerId: notification.containerId,
  type: notification.type,
  wasteName: notification.wasteName,
  addressName: notification.addressName,
  fillingLevel: notification.fillingLevel,
  limitFillingLevel: notification.limitFillingLevel,
});
